import styles from './Post.module.scss';

export default function PostBadge({text}) {
    if (text === null) return null; 
  return <div className={styles.badge}>{text}</div>;
}
